import {Component, Input, OnInit} from "@angular/core";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: "frontend-status-small",
  templateUrl: "./small.component.html",
  styleUrls: ["./small.component.css"]
})
export class SmallComponent implements OnInit {

  @Input() frontend: string = "";
  @Input() status: string = "";

  constructor(
    private viewManager: ViewManagerService,
  ) {
  }

  ngOnInit(): void {
    let prefix = environment.apiPrefix
    if (this.frontend == "batch") {
      prefix = environment.batchPrefix
    }
    if (this.frontend == "realtime") {
      prefix = environment.realtimePrefix
    }
    if (this.frontend == "nlp") {
      prefix = environment.servicesNlpPrefix
    }
    if (this.frontend == "ocr") {
      prefix = environment.servicesOcrPrefix
    }
    if (this.frontend == "ai") {
      prefix = environment.servicesAiPrefix
    }

    this.viewManager.healthCheck(prefix)
      .pipe()
      .subscribe({
        next: (result) => {
          this.status = result.status
        },
        error: error => {
          this.status = "error.access"
        }
      });
  }
}
